<template>
    <div class="opportunity-type-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Opportunity Type</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-screen-svg v-if="isLoading" />
                <div class="form-wrapper" v-else>
                    <div class="input-container">
                        <app-input
                            v-model="opportunityType.name"
                            label="Name"
                            placeholder="Name"
                            :isValid="!submitted || $v.opportunityType.name.required"
                            :error="`Name is required`" 
                        />
                    </div>
                </div>
            </div> 
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppInput = () => import('@/components/common/app-input.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
import { required} from 'vuelidate/lib/validators';

export default {
    name: 'opportunity-type-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
        'loading-screen-svg': LoadingScreenSvg,
    },

    data() {
        return {
            submitted: false,
            isLoading: true,
            opportunityType: {
                id: this.widget.opportunityTypeId,
                clientId: this.widget.clientId,
                name: null,
            },
        }
    },

    validations: {
        opportunityType: {
            name: {
                required
            },
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        save() {
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            if(this.opportunityType.id) {
                this.patch();
            } 
            else {
                this.post();
            }
        },

        patch() {
            this.isLoading = true;

            var changes = [{
                'name': 'Name',
                'value': this.opportunityType.name
            }];

            this.$api
                .patch(`/api/DealTypes/${ this.opportunityType.id }`, changes)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your opportunity type has been successfully updated.');
                    EventBus.$emit('opportunity-type:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while updating your opportunity type.', { error });
                });
        },

        post() {
            this.isLoading = true;

            var opportunityType = {
                Name: this.opportunityType.name,
                ClientId: this.opportunityType.clientId,
            };

            this.$api
                .post(`/api/DealTypes`, opportunityType)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your opportunity type has been successfully created.');
                    EventBus.$emit('opportunity-type:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while creating your opportunity type.', { error });
                });
        },

        getOpportunityType() {
            this.isLoading = true;

            this.$api
                .get(`/service/DealTypes?$filter=Id eq ${ this.opportunityType.id }`)
                .then(response => {
                    this.opportunityType.id = response.data.value[0].Id;
                    this.opportunityType.name = response.data.value[0].Name;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while fetching your opportunity type.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    created() {
        if (this.opportunityType.id) {
            this.getOpportunityType();
        }
        else {
            this.isLoading = false;
        }
    }
}
</script>

<style>
.opportunity-type-widget .form-wrapper {
    display: flex;
    flex-direction: column;
}

.opportunity-type-widget .widget-contents-container .transparent-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.opportunity-type-widget .widget-contents-container .transparent-btn:hover {
    background: #E1E0E5;
}

.opportunity-type-widget .input-container {
    margin-bottom: 1em;
}
</style>